import React from 'react';
import { Outlet } from 'react-router-dom'; // Import Outlet to render child routes
import Sidebar from './Sidebar';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { MdBorderColor } from 'react-icons/md';
const theme = createTheme({
    typography: {
        button: {
          textTransform: 'none'
        }
      },
      components: {
        // MuiTooltip: {
        //   defaultProps: {
        //     arrow: true,
        //     enterDelay: 250,
        //     leaveDelay: 80,
        //     slotProps: {
        //       popper: {
        //         modifiers: [
        //           {
        //             name: 'preventOverflow',
        //             options: {
        //               boundary: 'viewport',
        //               padding: 12,
        //             },
        //           },
        //           {
        //             name: 'flip',
        //             options: {
        //               fallbackPlacements: ['top', 'bottom', 'right', 'left'],
        //             },
        //           },
        //         ],
        //       },
        //     },
        //   },
        //   styleOverrides: {
        //     tooltip: {
        //       backgroundColor: '#FFFFFF',
        //       border: '1px solid #E2E8F0',
        //       borderRadius: '12px',
        //       boxShadow: '0 8px 24px rgba(15,23,42,0.12)',
        //       color: '#0F172A',
        //       fontSize: '12.5px',
        //       fontWeight: 600,
        //       lineHeight: 1.45,
        //       maxWidth: '280px',
        //       padding: '8px 12px',
        //     },
        //     arrow: {
        //       color: '#FFFFFF',
        //       '&::before': {
        //         border: '1px solid #E2E8F0',
        //         boxShadow: '0 8px 24px rgba(15,23,42,0.12)',
        //       },
        //     },
        //   },
        // },
      },
  });
const App = () => {
    return (
        <ThemeProvider theme={theme}>
        <Sidebar>
            <Outlet />
        </Sidebar>
        </ThemeProvider>
    );
};

export default App;
